import type { ComponentType } from "react";
import { Navigate } from "react-router";

import { useAuth } from "@/hooks/use-auth.ts";

// User already logged in, this prevents them from accessing the login/register page
export function withGuestGuard(Component: ComponentType) {
    return function GuestGuarded() {
        const { authed } = useAuth();

        if (authed) {
            // already logged in → send them somewhere else
            return <Navigate to="/" replace />;
        }

        return <Component />;
    };
}
